import week from './week'
import month from './month'
import day from './day'
import plan from './plan'
import PlanRD from './plan-rd'
import templates from './templates'
import preview from './preview'
import PreviewRD from './preview-rd'

const views = {week, month, day, plan, templates, preview, 'plan-rd': PlanRD, 'preview-rd': PreviewRD}

export default views
